import type { ReactNode } from "react";
import type { PillColor } from "../lib/status";
import { statusMeta } from "../lib/status";

export function Pill({
  color = "default",
  children,
  title,
}: {
  color?: PillColor;
  children: ReactNode;
  title?: string;
}) {
  return (
    <span className={`pill pill-${color}`} title={title}>
      {children}
    </span>
  );
}

export function StatusPill({ status }: { status: string }) {
  const m = statusMeta(status);
  return <Pill color={m.color}>{m.label}</Pill>;
}
